import script from "./DetailPopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailPopUp.vue?vue&type=script&setup=true&lang=js"

import "./DetailPopUp.vue?vue&type=style&index=0&id=d7ee8cac&lang=css"

const __exports__ = script;

export default __exports__